import { Tooltip } from 'antd';
import React, { CSSProperties } from 'react';
import { Link } from 'react-router-dom';
import translations from 'translations';
import topNavMessage from './messages';

const ICON_COLOR = {
  desktop: { fill: '#424242', stroke: '#424242' },
  mobile: { fill: 'white', stroke: 'white' },
};

interface QuickOrderEntryProps {
  variant?: 'desktop' | 'mobile';
  style?: CSSProperties;
}

const QuickOrderSVG = ({ variant = 'desktop' }: { variant?: 'desktop' | 'mobile' }) => {
  const { fill, stroke } = ICON_COLOR[variant];
  const clipId = `quick-order-clip-${variant}`;
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="29" height="28" viewBox="0 0 29 28" fill="none">
      <g clipPath={`url(#${clipId})`}>
        <path
          d="M28.8687 22.4026C28.8828 22.4828 28.7732 22.6538 28.6954 22.6817L26.3507 23.5923C25.5125 23.9167 24.7982 24.5377 24.4586 25.375L23.4578 27.8346C23.4295 27.9009 23.2704 28.0265 23.2138 27.9951L22.9804 27.8556L21.9866 25.3681C21.6188 24.5726 20.9929 23.9621 20.1759 23.6237L17.7039 22.6573L17.5908 22.4584C17.5589 22.3991 17.665 22.2316 17.7358 22.2037L20.0946 21.2792C20.9504 20.9442 21.6401 20.3267 21.9866 19.4789L22.9769 17.0472C23.0016 16.981 23.1431 16.8763 23.2138 16.8728C23.2845 16.8728 23.4331 16.9705 23.4684 17.0542L24.4056 19.3847C24.7593 20.2674 25.4489 20.9268 26.3365 21.2722L28.6706 22.1793C28.7413 22.2072 28.8545 22.3328 28.8687 22.4026Z"
          fill={fill}
        />
        <path
          d="M15.179 18.202L11.9996 8.40891C11.9572 8.2868 11.7627 8.15771 11.6566 8.15771H10.1713C10.0616 8.15771 9.88128 8.29029 9.83884 8.41938L6.65246 18.2229C6.57112 18.4811 6.77624 18.6904 6.99903 18.6904L7.87609 18.6974C7.98572 18.7009 8.20144 18.5753 8.23327 18.4811L8.74253 16.8623H13.0712L13.6052 18.4706C13.6406 18.5788 13.8386 18.6939 13.9483 18.7009L14.8359 18.6939C14.9279 18.6904 15.1082 18.5997 15.1542 18.5265C15.1931 18.4637 15.2108 18.2962 15.179 18.202ZM9.273 15.2923L10.9245 10.2824L12.5761 15.2923H9.273Z"
          fill={fill}
        />
        <path
          d="M19.2037 8.56235V18.2961C19.2037 18.495 19.0623 18.6869 18.8536 18.6869L18.0013 18.6939C17.7785 18.6939 17.6123 18.5334 17.6123 18.2961V8.56235C17.6123 8.32162 17.7785 8.16113 18.0049 8.16113H18.8112C19.0375 8.16113 19.2037 8.32162 19.2037 8.56235Z"
          fill={fill}
        />
        <path
          d="M23.7627 13.9663V5.46631C23.7627 4.36174 22.8673 3.46631 21.7627 3.46631H5.7627C4.65813 3.46631 3.7627 4.36174 3.7627 5.46631V21.9663C3.7627 23.0709 4.65813 23.9663 5.7627 23.9663H14.7627"
          stroke={stroke}
          strokeWidth="1.6"
        />
      </g>
      <defs>
        <clipPath id={clipId}>
          <rect width="29" height="28" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

const QuickOrderEntry = ({ variant = 'desktop', style }: QuickOrderEntryProps) => {
  if (variant === 'mobile') {
    return (
      <Link to="/quick-order" style={{ display: 'flex', alignItems: 'center', ...style }}>
        <QuickOrderSVG variant="mobile" />
      </Link>
    );
  }

  return (
    <Tooltip
      placement="bottom"
      title={translations(topNavMessage.quickOrderTooltip)}
      color="#424242"
      styles={{ body: { borderRadius: 8, padding: 12 } }}
    >
      <span style={{ display: 'inline-flex', alignItems: 'center' }}>
        <QuickOrderSVG variant="desktop" />
      </span>
    </Tooltip>
  );
};

export default QuickOrderEntry;
